import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import ReactionPanelContext from './ReactionPanel.context';
import ReactionIcon from './components/ReactionIcon';
import { ChildrenPropType } from '../../../../services/proptypes';
import './ReactionPanel.css';
var defaultProps = {
  initialActiveId: null,
  onClick: function onClick() {
    return null;
  },
  className: '',
  activeId: null
};
export default function ReactionPanel(_ref) {
  var children = _ref.children,
    initialActiveId = _ref.initialActiveId,
    onClick = _ref.onClick,
    className = _ref.className,
    activeIdProp = _ref.activeId;
  var _useState = useState(initialActiveId),
    _useState2 = _slicedToArray(_useState, 2),
    activeId = _useState2[0],
    setActiveId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    disabled = _useState4[0],
    setDisabled = _useState4[1];
  function handleClick(_x, _x2) {
    return _handleClick.apply(this, arguments);
  }
  function _handleClick() {
    _handleClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(newActiveId, recaptchaToken) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onClick(newActiveId, recaptchaToken);
          case 2:
            setActiveId(newActiveId);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleClick.apply(this, arguments);
  }
  var value = {
    activeId: activeIdProp || activeId,
    setActiveId: handleClick,
    disabled: disabled,
    setDisabled: setDisabled
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "reaction-panel ".concat(className)
  }, /*#__PURE__*/React.createElement(ReactionPanelContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children)));
}
ReactionPanel.defaultProps = defaultProps;
ReactionPanel.ReactionIcon = ReactionIcon;